import React, { useEffect } from 'react';
import SectionTelegram from '../LandingPage1/components/SectionTelegram';
import * as S from './styles';

const PreselTelegram: React.FC = () => {
  useEffect(() => {
    // Função para inserir o script do Google Tag Manager no head
    const insertGTMHeadScript = () => {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PLS7XG3N');
      `;
      document.head.appendChild(script);
    };

    insertGTMHeadScript();
  }, []);

  useEffect(() => {
    // Função para inserir o script do Google Tag Manager no body
    const insertGTMScript = () => {
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-PLS7XG3N';
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.appendChild(noscript);
    };

    insertGTMScript();
  }, []);

  return (
    <>
      <SectionTelegram />
      <S.Footer>
        <ul>
          <li>VITOR KAWANO</li>
          <li>TODOS DIREITOS RESERVADOS</li>
          <li>2024</li>
        </ul>
      </S.Footer>
    </>
  );
};

export default PreselTelegram;
